/* src/app/core/components/day-counter/day-counter.component.scss */
.train {
  width: 14.28%;
  background: #4ac8f3;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 14px 44px 14px 14px;
  z-index: 1;
}
.train .train-img {
  min-width: 65px;
  position: absolute;
  right: 0;
  padding-right: 10px;
  padding-top: 5px;
}
.train img {
  width: fit-content;
  height: fit-content;
}
.d-count {
  margin-top: var(--ion-safe-area-top);
}
.d-count-top {
  top: calc(var(--ion-safe-area-top) + 0.5rem) !important;
}
.day-count {
  position: absolute;
  top: 20px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  width: 100%;
  text-align: center;
}
.day-counter {
  position: relative;
  top: 55px;
  margin: 0 auto;
  width: 100%;
  max-width: 320px;
  height: fit-content;
  padding: 32px 10px 5px 10px;
  overflow: hidden;
  background: #c7eafa;
  border-radius: 14px;
}
.days {
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.day {
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #4ac8f3;
}
.day .line {
  padding: 2.5px 20px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 100px;
  margin: 5px 2px;
}
.default-border {
  border-radius: 14px;
}
/*# sourceMappingURL=day-counter.component.css.map */
